'use client'

import { CircularProgressIndicator } from '@/shared/design-system/components'

interface ICarStoryTabLoadingProps {
  /** false면 전체 화면이 아닌 영역 내 인라인 레이아웃으로 표시 */
  fullScreen?: boolean
}

const CarStoryTabLoading = ({
  fullScreen = true,
}: ICarStoryTabLoadingProps) => {
  return (
    <div
      className={
        fullScreen
          ? 'absolute top-0 left-0 h-dvh w-full flex flex-col items-center justify-center'
          : 'py-dimension-x16 flex w-full flex-col items-center justify-center'
      }
    >
      <CircularProgressIndicator size='medium' variant='gray' />
    </div>
  )
}

export default CarStoryTabLoading
